"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import { frontendImage } from "@/lib/helpers";
import Link from "next/link";
import Image from "next/image";
import WalletItemsSkeleton from "./_skeletons/WalletItemsSkeleton";

export const WalletItemsSection = () => {
    const { trans } = useUtility();
    const { elements, loading } = useSection("wallet_items");

    if (loading) return <WalletItemsSkeleton />;

    return (
        <section className="wallet-item-section section-bg">
            <div className="container wallet-container">
                <div className="row gy-3">
                    {elements?.map((item, index) => (
                        <div key={index} className="col-lg-4 col-sm-6">
                            <div className={`wallet-item-card ${index === 1 ? "two" : index === 2 ? "three" : ""}`}>
                                {/* Link Icon */}
                                <Link href={`/${item?.link || ""}`} className="wallet-item-card__link">
                                    <span className="wallet-item-card__link-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="none">
                                            <path d="M14.4766 3H21.4766V10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M21.4766 14.7368V19.5C21.4766 20.3285 20.805 21 19.9766 21H4.97656C4.14814 21 3.47656 20.3285 3.47656 19.5V4.5C3.47656 3.67158 4.14814 3 4.97656 3H9.47656" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13.375 11.1031L21.025 3.45312" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </Link>

                                {/* Content */}
                                <div className="wallet-item-card__content text-center">
                                    <h6 className="wallet-item-card__title">{trans(item?.title)}</h6>
                                    <p className="wallet-item-card__desc">{trans(item?.description)}</p>
                                </div>

                                {/* Image */}
                                <div className="wallet-item-card__thumb">
                                    <Image src={frontendImage(item?.thumbnail, "wallet_items")} alt={trans(item?.title)} width={244} height={327} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
